var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPortfolioBanner(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 338,
    height: 308,
    viewBox: "0 0 338 308",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4744_13336",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 338,
    height: 308
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 338,
    height: 308,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4744_13336)"
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 48.5,
    cy: 20.5,
    r: 287.5,
    fill: "#72A480"
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.1,
    cx: 90,
    cy: -33.5,
    rx: 163,
    ry: 163.5,
    fill: "#89AB93"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolioBanner);
export default __webpack_public_path__ + "static/media/portfolio-banner.9efa552b60a125b44345d292bdc8ae15.svg";
export { ForwardRef as ReactComponent };